import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const config = {
  headers: { "Content-Type": "application/json" },
};

export const getOoraTrafficDatasetList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_TRAFFIC_DATASET_LIST_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/oora-traffic-dataset/list`, // check mount path
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_TRAFFIC_DATASET_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_TRAFFIC_DATASET_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_OORA_TRAFFIC_DATASET_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const viewOoraTrafficDataset = (id, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_TRAFFIC_DATASET_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/oora-traffic-dataset/view`, // check mount path
        { id },
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_TRAFFIC_DATASET_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_TRAFFIC_DATASET_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_OORA_TRAFFIC_DATASET_FAIL", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

// formData = { sector: "Sector 137" }
export const fetchOoraTrafficDataset = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "FETCH_OORA_TRAFFIC_DATASET_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/oora-traffic-dataset/sync`, // check mount path
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "FETCH_OORA_TRAFFIC_DATASET_SUCCESS", payload: data });
      } else {
        dispatch({ type: "FETCH_OORA_TRAFFIC_DATASET_FAILED", payload: data });
      }

      return data; // component can check data.data.already_exists
    } catch (error) {
      dispatch({ type: "FETCH_OORA_TRAFFIC_DATASET_FAILED", payload: error });
      return { statusCode: 500, message: error?.response?.data?.message || "Something went wrong" };
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const removeOoraTrafficDataset = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "REMOVE_OORA_TRAFFIC_DATASET_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/oora-traffic-dataset/remove`, // check mount path
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_OORA_TRAFFIC_DATASET_SUCCESS", payload: data });
      } else {
        dispatch({ type: "REMOVE_OORA_TRAFFIC_DATASET_FAILED", payload: data });
      }

      return data;
    } catch (error) {
      dispatch({ type: "REMOVE_OORA_TRAFFIC_DATASET_FAILED", payload: error });
      return { statusCode: 500, message: error?.response?.data?.message || "Something went wrong" };
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const getOoraJamPatchList = (formData, type = "patches", showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_OORA_JAM_PATCH_LIST_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/oora-traffic-dataset/${type}`, formData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_OORA_JAM_PATCH_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_OORA_JAM_PATCH_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_OORA_JAM_PATCH_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};
 
// one live reading of all routes (the cron does this every hour, this is the manual button)
export const liveSyncOoraTraffic = (formData = {}, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIVE_SYNC_OORA_TRAFFIC_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/oora-traffic-dataset/live-sync`, formData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "LIVE_SYNC_OORA_TRAFFIC_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIVE_SYNC_OORA_TRAFFIC_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({ type: "LIVE_SYNC_OORA_TRAFFIC_FAILED", payload: error });
      return { statusCode: 500, message: error?.response?.data?.message || "Something went wrong" };
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};